import React from 'react';
import { useProto } from '../../contexts/PrototypeContext';
export function StaffingRolesSection() {
  const {
    state,
    actions
  } = useProto();
  return <section aria-labelledby="staff-roles" data-id="element-180" data-mp="1z6u1r3hc45e8">
      <div className="flex items-end justify-between border-b border-connect-line pb-1.5" data-id="element-181" data-mp="23zdgi3rrd6km">
        <h3 id="staff-roles" className="text-[17px] font-medium text-connect-blue" data-id="element-182" data-mp="28z8683zsrq43">Volunteer Roles</h3>
        <span className="text-xs text-connect-muted" data-id="element-183" data-mp="1bbhq1gss8awa">Existing staffing settings</span>
      </div>
      <div className="mt-5 grid grid-cols-3 gap-8" data-id="element-184" data-mp="1g9j5zsuwvu3j">
        {state.config.staffing.map(r => <div key={r.id} data-id="element-185" data-mp="1l8mb1daw60bi">
            <p className="font-medium text-connect-ink" data-id="element-186" data-mp="1l8clfqtrdv6c">{r.label}</p>
            <label className="mt-2 flex items-center gap-2 text-sm text-connect-ink" data-id="element-187" data-mp="1pb8x0xkvsr0s">
              <input type="checkbox" checked={r.needed} onChange={e => actions.updateStaffing(r.id, {
            needed: e.target.checked
          })} className="h-4 w-4 accent-connect-blue" data-id="element-188" data-mp="2wokpjwou9ek4" />
              Need {r.plural}
            </label>
            <label className="mt-4 block text-xs text-connect-muted" data-id="element-189" data-mp="3pnr4xqneh93p">
              Number needed
              <input type="number" min={0} value={r.count} disabled={!r.needed} onChange={e => actions.updateStaffing(r.id, {
            count: Math.max(0, parseInt(e.target.value || '0', 10) || 0)
          })} className="mt-1 block w-full border-0 border-b border-gray-400 bg-transparent px-0 py-1.5 text-[15px] text-connect-ink outline-none focus:border-b-2 focus:border-connect-blue disabled:text-gray-400" data-id="element-190" data-mp="3ko4q5crxbkss" />
            </label>
          </div>)}
      </div>
    </section>;
}